import React, { Component } from 'react';
import PopupContext from '../../context/context-popup';
import Row from '../row';

export default class SidePopup extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);
        this.clickHandler = this.handleOutsideClick.bind(this);
        this.ref = null;
    }


    componentDidMount() {
        setTimeout(() => {
            window.addEventListener('click', this.clickHandler);

        },100);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.clickHandler);
    }

    handleOutsideClick(e) {
        if (window.innerWidth <= 991) return;

        if (this.ref && !this.ref.contains(e.target) && e.target.className !== 'select-dropdown__item') {
            this.context.closePopup();
        }

    }

    render() {
        const { title, children, className = '', set, back = true, onClose = () => {} } = this.props;
        const isTablet = false;

        const { closePopup } = this.context;

        return (
            <div className={`side-popup ${className}`} ref={r => this.ref = r}>
                <div className="side-popup__header">
                    <Row gap="20px" alignItems="center" justifyContent='space-between' style={{ width: '100%' }}>
                        <h1 className='side-popup__title'>{title}</h1>
                        <span className="side-popup__close side-popup__close--large" onClick={closePopup}>
                        <img src="/assets/close.svg" />
                    </span>
                    </Row>
                </div>
                <div className="side-popup__content">
                    { children }
                </div>
            </div>
        )
    }

}
